(function ($) {
  DJ.addBehavior('latestNews', '.latest-news', {
    attach: function () {
      const holder = this;
      const background = holder.querySelector('.latest-news__bg');
      const newsHolder = holder.querySelector('.latest-news__holder');
      const image = holder.querySelector('.latest-news-block__img');

      if (!background || !newsHolder || !image) {
        return;
      }

      // Calculate height for the latest news background.
      DJ.behaviors.calculateNewsBg.calculate(image, newsHolder, background);
    }
  });
})(jQuery);
